import { Component } from 'react';
import { Svg } from '../Gauge';
import {
   formatLabelIdAndId,
   GAUGE_CENTER_COORDINATES,
   GaugeCoordinates,
   GaugeElementId,
   QUARTER_CIRCLE_DEGREES,
   updateLabelColorById,
   updateLabelTextById
} from '../shared/GaugeShared';

export interface GaugeLeftVerticalLabelProps {
   svg: Svg;
   svgId: string;
   labelsColor: string;
   leftVerticalLabel: string;
}

export class GaugeLeftVerticalLabel extends Component<GaugeLeftVerticalLabelProps> {
   private LEFT_VERTICAL_LABEL_POSITION: GaugeCoordinates = {
      x: 50,
      y: 2
   };
   private LEFT_VERTICAL_LABEL_SIZE = 13;
   private LEFT_VERTICAL_LABEL_WEIGHT = 'bold';

   constructor(props: GaugeLeftVerticalLabelProps) {
      super(props);

      this.drawGaugeLeftVerticalLabel(props);
   }

   render(): null {
      return null;
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeLeftVerticalLabelProps): void {
      this.updateGaugeLeftVerticalLabel(nextProps);
   }

   drawGaugeLeftVerticalLabel = (props: GaugeLeftVerticalLabelProps): void => {
      props.svg.draw.text(props.leftVerticalLabel)
         .move(this.LEFT_VERTICAL_LABEL_POSITION.x, this.LEFT_VERTICAL_LABEL_POSITION.y)
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.LEFT_VERTICAL_LABEL, props.svgId)
               })
         .transform({
                       rotation: -QUARTER_CIRCLE_DEGREES,
                       cx: GAUGE_CENTER_COORDINATES.x,
                       cy: GAUGE_CENTER_COORDINATES.y
                    })
         .font({
                  fill: props.labelsColor,
                  size: this.LEFT_VERTICAL_LABEL_SIZE,
                  weight: this.LEFT_VERTICAL_LABEL_WEIGHT,
                  anchor: 'middle',
                  family: 'sans-serif'
               });
   };

   updateGaugeLeftVerticalLabel = (props: GaugeLeftVerticalLabelProps): void => {
      updateLabelTextById(formatLabelIdAndId(GaugeElementId.LEFT_VERTICAL_LABEL, props.svgId), props.leftVerticalLabel);
      updateLabelColorById(formatLabelIdAndId(GaugeElementId.LEFT_VERTICAL_LABEL, props.svgId), props.labelsColor);
   };
}
